define([
  "marionette",
  "underscore",
  "messaging/messenger",
  "configuration/properties",
  "./template/taskWizardStepsPageTemplate.html",
], function (Marionette, _, Messenger, Properties, TaskWizardStepsPageTemplate) {
  "use strict";

  var TaskWizardStepsPageView = {};

  TaskWizardStepsPageView.stepsPageView = Marionette.Layout.extend({
    className: "form-horizontal task-wizard-steps-page",
    template: TaskWizardStepsPageTemplate,
    regions: {
      localeSteps: ".locale-steps",
      taskSteps: ".task-steps",
    },
    ui: {
      taskDescription: ".task-description",
      taskDescriptionError: ".task-description-error",
      taskName: ".task-name",
      taskNameError: ".task-name-error",
      taskStepsError: ".task-steps-error",
    },
    clearErrors: function () {
      this.ui.taskNameError.html("");
      this.ui.taskDescriptionError.html("");
      this.ui.taskStepsError.html("");
    },
    descriptionError: function (message) {
      this.ui.taskDescriptionError
        .html('<h5 class="error-message">' + _.escape(message) + "</h5>")
        .hide()
        .fadeIn();
    },
    nameError: function (message) {
      this.ui.taskNameError
        .html('<h5 class="error-message">' + _.escape(message) + "</h5>")
        .hide()
        .fadeIn();
    },
    taskStepsError: function (message) {
      this.ui.taskStepsError
        .html('<h5 class="error-message">' + _.escape(message) + "</h5>")
        .hide()
        .fadeIn();
    },
    getTaskDescription: function () {
      var value = this.ui.taskDescription.val();
      var trimmedValue = value.trim();
      if (value != trimmedValue) {
        this.ui.taskDescription.val(trimmedValue);
      }
      return trimmedValue;
    },
    getTaskName: function () {
      var value = this.ui.taskName.val();
      var trimmedValue = value.trim();
      if (value != trimmedValue) {
        this.ui.taskName.val(trimmedValue);
      }
      return trimmedValue;
    },
  });

  return TaskWizardStepsPageView;
});
